// eslint-disable-next-line no-unused-vars
export default (...mappers: Function[]) => (data: any) => mappers.reduce((acc, f) => f(acc), data);
